/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { SubmitReviewButton } from '@/features/reviews/components/SubmitReviewButton/SubmitReviewButton';
import styles from './styles.module.scss';
import { useLabels } from '@/hooks/useLabels';
import { Text, View } from '@az/starc-ui';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { useRef, useState } from 'react';
import { Rating } from '../../../reviews/components/SubmitProductReviewModal/components/Rating/Rating';
import { useMyProfile } from '@/features/myProfile/api/getMyProfile';
import { usePreferredVehicle } from '@/features/header/hooks/usePreferredVehicle';

const labelMap = {
  noReviews: 'label_reviews_noReviewsFromCustomers',
  beTheFirst: 'label_reviews_beTheFirst',
  writeAReview: 'label_reviews_writeAReview2',
};

export const NoReviews = () => {
  const labels = useLabels(labelMap);
  const { data } = useProductDetails();
  const { data: myProfile } = useMyProfile();
  const preferredVehicle = usePreferredVehicle();

  const button = useRef<HTMLButtonElement>(null);
  const [rating, setRating] = useState<number | null>(null);

  const handleInitialRating = (rating: number | null) => {
    button.current?.click();
    setRating(rating);
  };

  return (
    <View>
      <Text variant="main-body" weight="bold" className={styles.noReviews}>
        {labels.noReviews}
      </Text>
      <View padding={0.5} />
      <Text variant="small-body" className={styles.smallBody}>
        {labels.beTheFirst}
      </Text>
      <View className={styles.starsContainer}>
        <Rating
          className={styles.stars}
          iconClassName={styles.star}
          inputClassName={styles.input}
          id="rating"
          labelID="rating-label"
          name="rating"
          onChange={handleInitialRating}
          value={rating}
        />
      </View>
      <View direction={'row'} justify={{ s: 'center', m: 'start' }}>
        <SubmitReviewButton
          ref={button}
          productId={data?.product?.itemId}
          productImage={data?.product?.itemImageUrl}
          productTitle={data?.product?.itemDescription}
          pageType="ProductDetail"
          defaultValues={{
            useremail: myProfile?.email,
            usernickname: myProfile?.firstName,
            vehicle: preferredVehicle?.vehicleName,
            rating,
          }}
          label={
            <Text variant="small-body" weight="bold" className={styles.smallBody}>
              {labels.writeAReview}
            </Text>
          }
          variant="pill-secondary"
          onClose={() => setRating(null)}
        />
      </View>
    </View>
  );
};
